import { render, staticRenderFns } from "./ReportOrdersVendorModal.vue?vue&type=template&id=6c7b1cb2&scoped=true&"
import script from "./ReportOrdersVendorModal.vue?vue&type=script&lang=js&"
export * from "./ReportOrdersVendorModal.vue?vue&type=script&lang=js&"
import style0 from "./ReportOrdersVendorModal.vue?vue&type=style&index=0&id=6c7b1cb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7b1cb2",
  null
  
)

export default component.exports